import React from 'react';

export default function FamphyLeadershipTeam() {
  return (
    <>
      <div className="container mb-5">

        {/* =========================================
            FAMPHY LEADERSHIP TEAM
        ========================================== */}

        <div className="specialized-section">
          <h2>
            FamPhy <span>Leadership Team</span>
          </h2>

          <p className="limit-width">
            At FamPhy, our commitment to providing exceptional medical care is
            driven by the expertise and dedication of our distinguished
            leadership team. Our leaders bring together extensive healthcare
            experience, operational expertise, and a shared commitment to
            delivering high-quality, patient-focused care.
          </p>
        </div>


        {/* =========================================
            DR. ANUDEEP KAUR
        ========================================== */}

        <div className="row justify-content-center famphy-leader-row">

          <div className="col-lg-10 col-md-11 col-sm-12">

            <div className="famphy-leader-card">

              {/* Doctor Image */}
              <div className="famphy-leader-image">

                <img
                  src={`${process.env.PUBLIC_URL}/img/famphy-team-dr-anudeep.png`}
                  alt="Dr. Anudeep Kaur - Co-Founder of FamPhy Clinics"
                />

              </div>


              {/* Doctor Information */}
              <div className="famphy-leader-info">

                <span className="famphy-leader-role">
                  CO-FOUNDER • FAMPHY CLINICS
                </span>

                <h3>
                  Dr. Anudeep Kaur
                </h3>

                <div className="famphy-leader-line"></div>

                <p className="famphy-leader-intro">
                  Healthcare leader with 15+ years of experience in healthcare
                  operations and management.
                </p>

                <p>
                  Dr. Anudeep Kaur is a healthcare professional and
                  <strong> Co-Founder of FamPhy Clinics</strong>, with 15+ years
                  of experience in the healthcare industry. An alumnus of IIHMR,
                  she has been a distinction holder in Healthcare Operations
                  and was selected by Johns Hopkins University for an exchange
                  programme with IIHMR.
                </p>

                <p>
                  Prior to co-founding FamPhy Clinics, she worked in various
                  leadership roles across multiple corporate hospitals. She
                  specializes in greenfield healthcare projects and scaling
                  healthcare operations to the next level.
                </p>

              </div>

            </div>

          </div>

        </div>

      </div>
    </>
  );
}

